export const truncar = (numero, decimales = 2) => {
    const factor = Math.pow(10, decimales);
    return Math.trunc(numero * factor / factor);
}